module.exports = __webpack_public_path__ + "img/document_PDF.249cfcf8.png";